import { put, take, takeEvery } from 'redux-saga/effects';
import ErrorTypes from './ErrorTypes';
import SessionTypes from '../session/SessionTypes';
import NotificationTypes from '../notification/NotificationTypes';
import {
  OK,
  ERR_UNAUTHORIZED,
  ERR_FORBIDDEN,
  ERR_USER_NOT_FOUND,
  ERR_PASSWORD_NOT_MATCH,
  ERR_INVALID_ROLE, ERR_NOT_FOUND
} from '../../configs/ApiStatus';

export default function * handleApiError () {
  yield takeEvery(ErrorTypes.API_RESPONSE_ERROR, showApiError);
}

function * showApiError (action) {
  const { response, callback, presentAction } = action;
  if (response) {
    const { status: httpStatus } = response;
    const {
      data: { status: apiStatus }
    } = response;
    switch (httpStatus) {
      case OK.status:
        // show alert error [API ERROR]
        yield _showNotification(apiStatus);
        break;

      case ERR_NOT_FOUND.status:
        yield _showNotification(apiStatus);
        break;

      case ERR_FORBIDDEN.status:
        yield _showNotification(ERR_FORBIDDEN.status);
        break;

      case ERR_USER_NOT_FOUND.status:
        yield _showNotification(ERR_USER_NOT_FOUND.status);
        break;

      case ERR_PASSWORD_NOT_MATCH.status:
        yield _showNotification(ERR_PASSWORD_NOT_MATCH.status);
        break;

      case ERR_INVALID_ROLE.status:
        yield _showNotification(ERR_INVALID_ROLE.status);
        break;

      case ERR_UNAUTHORIZED.status:
        // cache route to restore session after login
        yield put({ type: SessionTypes.CACHE_PREV_LOGIN_ROUTE });
        // Unauthorized or Access Token is expired => reauthorize
        yield put({ type: SessionTypes.REAUTHORIZE });

        if (presentAction) {
          yield take(SessionTypes.LOG_IN_SUCCESS);
          yield put(presentAction);
        }
        break;

      default:
        // show unknown error
        yield _showNotification('unknown');
    }
  } else {
    // show unknown error
    yield _showNotification('unknown');
  }

  callback && callback(response);
}

function * _showNotification (error) {
  yield put({
    type: NotificationTypes.SHOW_NOTIFICATION,
    payload: {
      config: {
        message: `api.error.${error}`,
        level: 'error',
        autoDismiss: 3
      }
    }
  });
}
